import PropTypes from "prop-types";
import LazyLoad from "react-lazyload";

import useCart from "../../../hooks/useCart";
import { useCurrentCountryCode, usePriceInfo } from "../../../hooks/usePrices";
import PriceContainer from "../../PriceContainer";
import ProductReviewRating from "../../ProductPage/ProductReviewRating";
import { ALSkeleton, ALTag } from "../../ALComponents";
import { ComponentType } from "../../../constants/ComponentType";
import { Country } from "../../../constants/Country";
import QuickAddToCartCarousel from "./QuickAddToCartCarousel";

import * as Styles from "./productCard/styles.module.scss";
import { Link } from "../../al_components/ALLink";

function ProductCard({ product }) {
  const image = product?.node?.images?.[0];
  const [{ data: prices, isInitialLoading: pricesLoading }] = usePriceInfo({
    handles: [product.node.handle],
    tags: { [product.node.handle]: product.node?.tags },
    shouldFetchPrice: true,
  });

  const countryCode = useCurrentCountryCode();
  const isPreOrder = product?.contentful?.isPreOrder;

  const hasNoVariantsAvailable = product.node.variants?.every(
    (x) => x.availableForSale === true && x.inventoryPolicy !== "DENY"
  );

  const shouldDisplayPreOrder = isPreOrder && countryCode === Country.US && hasNoVariantsAvailable;

  const { quickAddToCart } = useCart(product, prices);

  if (!product) {
    return null;
  }

  return (
    <div className={Styles.product_wrapper}>
      <LazyLoad
        style={{ width: "100%" }}
        once
        placeholder={
          <div
            style={{
              position: "absolute",
              width: "100%",
              paddingBottom: "100%",
              height: "100%",
            }}
          >
            <ALSkeleton width="100%" height="100%" />
          </div>
        }
      >
        <Link to={`/products/${product?.contentful?.handle}/`}>
          <img src={`${image.url}?fm=webp`} alt={image.altText} />
        </Link>
        <div className={Styles.product_tag}>
          <ALTag
            product={product}
            componentType={ComponentType.CP}
            shouldDisplayPreOrder={shouldDisplayPreOrder}
          />
        </div>
        <div className={Styles.product_content}>
          <div className={Styles.product_content__left}>
            <Link
              className="subtext subtext--bold subtext--uc"
              to={`/products/${product?.contentful?.handle}/`}
            >
              {product.node.title.split(" - ")[1]}
            </Link>

            <ProductReviewRating type={ComponentType.PRODUCT_CAROUSEL} />
          </div>
          <PriceContainer
            productId={product.shopify.id}
            componentType={ComponentType.CP}
            prices={prices}
            pricesLoading={pricesLoading}
            tags={product.node.tags}
          />
        </div>
        <QuickAddToCartCarousel
          product={product?.shopify}
          onQuickAddToCart={quickAddToCart}
          collectionTitle="carousel"
        />
      </LazyLoad>
    </div>
  );
}

ProductCard.propTypes = {
  product: PropTypes.shape({
    node: PropTypes.shape({
      title: PropTypes.string,
      handle: PropTypes.string,
    }),
    shopify: PropTypes.shape(),
  }),
};
export default ProductCard;
